/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ValueBaseContract} from '../../api/contracts/value-base.contract';
import {ValueBaseModel} from './value-base.model';


export class ValueBaseMapper {
    static fromValueBaseContractArray(input: ValueBaseContract[]): ValueBaseModel[] {
        return input?.map((element) => ValueBaseMapper.fromValueBaseContract(element));
    }

    static fromValueBaseContract(input: ValueBaseContract): ValueBaseModel {
        let model: ValueBaseModel;

        if (input != null) {
            model = {
                value: input.value,
                specCode: input.specCode
            };
        }
        return model;
    }
}
